<template>
	<div class="wrap">
		<div class="switch">
			<el-radio-group v-model="activeSwitch" @input="switchTab">
				<el-radio-button label="课程学习"></el-radio-button>
				<el-radio-button label="我的题库"></el-radio-button>
				<!-- <el-radio-button label="我的电子书"></el-radio-button> -->
				<!-- <el-radio-button label="错题"></el-radio-button> -->
				<el-radio-button label="收藏"></el-radio-button>
			</el-radio-group>
		</div>
		<router-view></router-view>
	</div>
</template>

<script>
	export default {
		name: 'home',
		data() {
			return {
				activeSwitch: '课程学习',
			};
		},
		methods: {
			switchTab(active) {
				this.activeSwitch = active;
				if (active === '课程学习') {
					this.$router.push('/home/myVideo');
				}
				if (active === '我的题库') {
					this.$router.push('/home/myTestPaper');
				}
				if (active === '我的电子书') {
					this.$router.push('/home/myEbook');
				}
				// if (active === '错题') {
				// 	this.$router.push('/home/errorCollect');
				// }
				if (active === '收藏') {
					this.$router.push('/home/collectQuestions');
				}
			},
		},
	};
</script>

<style scoped>
	.wrap {
		width: 1340px;
		margin: auto;
		margin-top: 10px;
		margin-bottom: 125px;
		box-sizing: border-box;
		bottom: solid 1px red;
	}
	.switch {
		cursor: pointer;
		margin-bottom: 10px;
	}
	.switch-part {
		border-radius: 18px;
		flex: 1;
		text-align: center;
	}
	.active-switch {
		background-color: #fff;
		color: #f7a178;
		box-shadow: 0px 0px 10px 0px rgba(120, 120, 120, 0.3);
	}
</style>



// WEBPACK FOOTER //
// src/views/home/index.vue